/**
 * Created by felipe on 7/22/24.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('quiz-submission', {
                parent: 'site',
                url: '/quizzing/submission/:collectionId/:assetId/:quizId/:isPreview',
                params: {
                },
                data: {
                    roles: [],
                    pageTitle: 'quizzing.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/quizzing/templates/quiz-submission.html',
                        controller: 'QuizSubmissionController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('quizzing');
                        return $translate.refresh();
                    }]
                }
            });
    });
